<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 sm6 md6 lg6>
          <h1 class="headline">{{ $t('roles.title') }}</h1>
        </v-flex>

        <v-flex xs12 sm6 md6 lg6>
          <v-layout wrap align-center justify-end>
            <v-btn
              v-if="$can('role_add')"
              to="/roles/add"
              color="warning mt-2"
              large
              depressed
            >
              {{ $t('roles.add') }}
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-checkbox
      v-if="isAdmin"
      v-model="withTrashed"
      color="warning"
      true-value="1"
      false-value="0"
      hide-details
      :label="$t('common.labels.showDeleted')"
    />

    <v-flex mt-5 mb-5 xs12>
      <v-data-table
        :headers="headers"
        :items="list"
        :loading="loading"
        :items-per-page="-1"
        hide-default-footer
      >
        <template #item="{ item }">
          <tr :class="{ 'deleted-row': item.deleted_at }">
            <td v-if="isAdmin">
              <v-btn
                v-if="item.deleted_at"
                class="restore-btn"
                color="warning"
                small
                icon
                :loading="restoreItems.includes(item.id)"
                @click="
                  () => {
                    confirmDialog.value = true;
                    confirmDialog.title = $t('common.restore') + ' ?';
                    confirmDialog.action = () => restoreItem(item.id);
                  }
                "
              >
                <v-icon small>mdi-restore</v-icon>
              </v-btn>
              <v-btn
                v-else
                color="red"
                small
                icon
                :loading="deletingItems.includes(item.id)"
                :disabled="Boolean(item.protected) || Boolean(item.deleted_at)"
                @click="
                  () => {
                    confirmDialog.value = true;
                    confirmDialog.title = $t('common.btns.delete') + ' ?';
                    confirmDialog.action = () => deleteItem(item.id);
                  }
                "
              >
                <v-icon small>{{
                  item.protected
                    ? 'mdi-delete-off-outline'
                    : 'mdi-trash-can-outline'
                }}</v-icon>
              </v-btn>
            </td>
            <td>{{ item.num }}</td>
            <td>
              {{ item.updated_at }}
            </td>
            <td>
              <button
                class="role-list__btn"
                text
                small
                @click="$router.push(`/roles/edit/${item.id}`)"
              >
                {{ item.displayName }}
              </button>
            </td>
            <td>
              {{ item.description }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>

    <confirm-dialog
      v-model="confirmDialog.value"
      :title="confirmDialog.title"
      @confirm="confirmDialog.action"
    />
  </v-layout>
</template>

<script>
import ConfirmDialog from '../../components/shared/ConfirmDialog.vue';
import enumerateArray from '@/helpers/enumerateArray';

export default {
  components: { ConfirmDialog },
  data: () => ({
    loading: false,
    dialog: false,
    withTrashed: 0,
    deletingItems: [],
    restoreItems: [],
    confirmDialog: {
      value: false,
      title: null,
      action: () => {},
    },
  }),
  watch: {
    withTrashed() {
      this.fetchList();
    },
  },
  computed: {
    headers() {
      const items = [
        {
          text: this.$t('common.number'),
          value: 'num',
          sortable: false,
        },
        {
          text: this.$t('roles.updated'),
          value: 'updated_at',
          sortable: false,
        },
        {
          text: this.$t('roles.role-name'),
          value: 'displayName',
          sortable: false,
        },
        {
          text: this.$t('common.table.description'),
          value: 'description',
          sortable: false,
        },
      ];

      if (this.isAdmin) {
        items.unshift({
          text: '',
          value: 'actions',
          sortable: false,
        });
      }

      return items;
    },
    list() {
      const { list } = this.$store.state.roles;
      const listCopy = [...list];
      const sortedList = listCopy.sort((item) => (item.protected ? -1 : 0));
      return enumerateArray(sortedList);
    },
    isAdmin() {
      return this.$store.getters['global/getRole'] === 'admin';
    },
  },
  methods: {
    async fetchList() {
      this.loading = true;
      await this.$store.dispatch('roles/fetchList', {
        withTrashed: this.withTrashed,
      });
      this.loading = false;
    },
    async deleteItem(id) {
      this.deletingItems.push(id);

      await this.$store.dispatch('roles/deleteItem', id);
      await this.fetchList();

      this.deletingItems = this.deletingItems.filter((item) => item !== id);
    },
    async restoreItem(id) {
      this.restoreItems.push(id);

      await this.$store.dispatch('roles/restoreItem', id);
      await this.fetchList();

      this.restoreItems = this.restoreItems.filter((item) => item !== id);
    },
  },
  created() {
    this.fetchList();
  },
};
</script>

<style lang="scss">
.role-list__btn {
  text-decoration: underline;
  font-weight: 600;
  color: #464646;
}

.role-list__btn:hover {
  text-decoration: none;
}

.confirm-title {
  width: 100%;
  text-align: center;
  font-size: 14;
}

.v-pagination__item,
.v-pagination__navigation {
  box-shadow: none;
}
</style>
